import React from 'react';
import { Box, VStack, Heading, Spinner, Text, Center, HStack } from '@chakra-ui/react';

interface InfoSectionProps {
    title?: string;
    children: React.ReactNode;
    gap?: number;
    separator?: boolean;
    isLoading?: boolean;
    loadingLabel?: string;
    isUpdate?: boolean;
    rightButton?: React.ReactNode;
}

export const InfoSection: React.FC<InfoSectionProps> = ({
    title,
    children,
    gap = 3,
    separator = true,
    isLoading = false,
    loadingLabel,
    isUpdate = false,
    rightButton,
}) => {
    const childrenArray = React.Children.toArray(children);

    return (
        <Box p={6} bg="white" w={{ base: 'full', md: '600px' }} mx="auto">
            {title && (
                <Heading size="lg" color="gray.800" mb={4}>
                    <HStack gap={2} align="center" justify="space-between">
                        <HStack>
                            <Heading size="lg" color="gray.800">
                                {title}
                            </Heading>
                            {rightButton}
                        </HStack>
                        <HStack gap={2} align="center">
                            {isUpdate && <Spinner size="sm" color="yellow.600" />}
                        </HStack>
                    </HStack>
                </Heading>
            )}
            {isLoading ? (
                <Center py={8}>
                    <VStack gap={3}>
                        <Spinner size="lg" color="yellow.600" />
                        {loadingLabel && (
                            <Text fontSize="md" color="gray.600">
                                {loadingLabel}
                            </Text>
                        )}
                    </VStack>
                </Center>
            ) : (
                <VStack gap={gap} align="stretch">
                    {childrenArray.map((child, index) => (
                        <Box key={index}>
                            {child}
                            {separator && index < childrenArray.length - 1 && (
                                <Box mt={gap} mb={0} h="1px" bg="gray.200" />
                            )}
                        </Box>
                    ))}
                </VStack>
            )}
        </Box>
    );
};
